import eye from "./eye.svg";
import styled from "styled-components";

export const logo = eye;

export const StyledInput = styled.div`
	@font-face {
		font-family: "password";
		font-weight: 500;
		src: url(https://jsbin-user-assets.s3.amazonaws.com/rafaelcastrocouto/password.ttf);
	}
	position: relative;
	width: 100%;
	font-size: 16px;
	font-family: "Montserrat", sans-serif;
	text-align: left;

	input[type="id"] {
		padding-left: 25%;
	}
	input[type="phone"] {
		padding-left: 10%;
	}
	.show-password-font {
		font-family: "password";
		letter-spacing: 1.4px;
		::placeholder {
			/* Chrome, Firefox, Opera, Safari 10.1+ */
			font-family: sans-serif;
			opacity: 1; /* Firefox */
			color: #777777;
			letter-spacing: 0.2px;
		}
	}
	input:focus {
		border-color: #145ab4;
	}
	label {
		position: relative;
		color: #1f1f1f;
		font-weight: 500;
		cursor: text;
		pointer-events: none;
	}
	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="phone"] {
		-moz-appearance: textfield;
	}
`;

export const InputStyled = styled.input`
	display: block;
	position: relative;
	width: 100%;
	padding: 0.5em;
	padding-left: ${(props) => props.type === "phone+" && "62px"};
	margin: 4px 0;
	font-weight: 400;
	letter-spacing: 0.2px;
	background: #fefefe;
	color: #030303;
	border: ${({ error, name }) => {
		if (error) {
			if (error.passwordMessage && name === "password") {
				return "1px solid red";
			} else if (error.EmailMessage && name === "email") {
				return "1px solid red";
			} else {
				return "1px solid #a2a2a2";
			}
		}
		return "1px solid #a2a2a2";
	}};
	border-radius: 8px;
`;

export const StyledSelect = styled.select`
	width: 20%;
	text-align: center;
	position: absolute;
	top: 2.1rem;
	left: 3%;
	height: 40%;
	border: none;
	border-right: solid 1px black;
	border-radius: 5px 0 0 5px;
	appearance: none;
	font-weight: 400;
	color: #1f1f1f;
	&:hover {
		background: #f7f7ff;
	}
`;

export const StyledSpan = styled.span`
	font-weight: 400;
	position: absolute;
	top: 27px;
	left: 12px;
	font-size: 24px;
	color: #1f1f1f;
`;

export const Eyebox = styled.div`
	width: auto;
	position: absolute;
	top: 47%;
	right: 0.5em;
	cursor: pointer;
	fill: #5d5d5d;
	font-weight: bold;
	transition: color 300ms ease;

	& svg {
		width: 24px;
	}

	svg .closed-eye-stripe {
		fill: transparent;
		opacity: 0;
		transition: all 300ms ease;
	}

	.closed-eye-stripe-show {
		svg .closed-eye-stripe {
			fill: #ffffff;
			opacity: 1;
			transition: all 300ms ease;
		}
	}
`;
